module.exports = __webpack_public_path__ + "6d56aa9cc6792722641375751d0a99c0.svg";